export const NotFound = ({ className }: { className: string }) => {
  return (
    <svg width="39" height="38" viewBox="0 0 39 38" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <g id="fi_11610944">
        <g id="Line-Black">
          <path
            id="Vector"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M27.1665 28.3468L35.2854 36.4646C35.7486 36.9277 36.5014 36.9277 36.9646 36.4646C37.4277 36.0014 37.4277 35.2486 36.9646 34.7854L28.8468 26.6665C31.1624 23.9673 32.5625 20.4583 32.5625 16.625C32.5625 8.10469 25.6453 1.1875 17.125 1.1875C8.60469 1.1875 1.6875 8.10469 1.6875 16.625C1.6875 25.1453 8.60469 32.0625 17.125 32.0625C20.9583 32.0625 24.4673 30.6624 27.1665 28.3468ZM17.125 3.5625C24.3343 3.5625 30.1875 9.41569 30.1875 16.625C30.1875 23.8343 24.3343 29.6875 17.125 29.6875C9.91569 29.6875 4.0625 23.8343 4.0625 16.625C4.0625 9.41569 9.91569 3.5625 17.125 3.5625Z"
            fill="#757575"
          />
          <path
            id="Vector_2"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.1249 14.9467L12.9259 10.7477C12.4628 10.2846 11.7111 10.2846 11.2468 10.7477C10.7836 11.212 10.7836 11.9637 11.2468 12.4269L15.4458 16.6259L11.2468 20.8249C10.7836 21.288 10.7836 22.0397 11.2468 22.504C11.7111 22.9671 12.4628 22.9671 12.9259 22.504L17.1249 18.305L21.3239 22.504C21.787 22.9671 22.5387 22.9671 23.003 22.504C23.4661 22.0397 23.4661 21.288 23.003 20.8249L18.804 16.6259L23.003 12.4269C23.4661 11.9637 23.4661 11.212 23.003 10.7477C22.5387 10.2846 21.787 10.2846 21.3239 10.7477L17.1249 14.9467Z"
            fill="#757575"
          />
        </g>
      </g>
    </svg>
  )
}
